export default __webpack_public_path__ + "static/media/banner-downloads.d43dd9d0.webp";